import React, { useContext } from "react";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";

//style
import "../../styles/allWorkExchangeModal.scss";

function TrackingStatus({ tracking }) {
  const {
    getLang,
  } = useContext(AppContext);

  const TranslationWorkExchange = getLang(langComponent.workExchange);


  const formatDate = (dateTime) => {
    const currentDate = new Date();
    const dateCreate = new Date(dateTime);

    const year = dateCreate.getUTCFullYear();
    const month = dateCreate.getUTCMonth() + 1;
    const day = dateCreate.getUTCDate();

    const dateTimeText = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return dateTimeText;
  };
  return (
    <div className="tracking-status-container">
      <div className="tracking-status-container-card">
        <div className="tracking-status-container-card-dot">
          <div className="tracking-status-container-card-dot-inner"></div>
        </div>
        <div className="tracking-status-container-card-detail">
          <div className="tracking-status-container-card-detail-ranking">
            <span className="tracking-status-container-card-detail-ranking__date">
              {formatDate(tracking.date)} :
            </span>
            <span className="tracking-status-container-card-detail-ranking__rank">
              {TranslationWorkExchange("Rank")} {tracking.rank}
            </span>
          </div>
          <div className="tracking-status-container-card-detail-number">
            <span>{`Number of people who promote : ${
              tracking.promoted ?? 0
            } person`}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

TrackingStatus.propTypes = {};

export default TrackingStatus;
